import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fcd0127"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "xag-flex",
  style: {"height":"100%","align-items":"center"}
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/images/general_icon_search_24.svg",
    style: {"height":"18px"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_network_points = _resolveComponent("network-points")!

  return (_openBlock(), _createElementBlock("div", {
    class: "filter-box",
    style: _normalizeStyle({ height: `${_ctx.fHeight}` })
  }, [
    _createVNode(_component_van_search, {
      ref: "searchbox",
      modelValue: _ctx.keywords,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywords) = $event)),
      modelModifiers: { trim: true },
      clearable: false,
      onFocus: _ctx.onFocus,
      "show-action": _ctx.isFocus || _ctx.keywords !== '',
      onCancel: _ctx.onCancel,
      placeholder: "输入关键词"
    }, {
      "left-icon": _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue", "onFocus", "show-action", "onCancel"]),
    _createVNode(_component_network_points, {
      class: "xag-container",
      keywords: _ctx.keywords,
      onClickItem: _ctx.onClickItem
    }, null, 8, ["keywords", "onClickItem"])
  ], 4))
}